import { useCallback } from "react";
import { useNavigate } from "react-router";

export default function useUpdateSearchParams() {
  const navigate = useNavigate();

  return useCallback(
    (updates, { replace = false } = {}) => {
      const params = new URLSearchParams(window.location.search);
      Object.entries(updates).forEach(([key, value]) => {
        if (value === null || value === undefined) {
          params.delete(key);
        } else {
          params.set(key, value);
        }
      });
      navigate({ search: params.toString() }, replace ? { replace: true } : undefined);
    },
    [navigate]
  );
}
